import angular from 'angular'

function contractCard() {
  return {
    restrict: 'E',
    replace: true,
    template: require('./_card-contract.html')
  }
}

export default angular.module('directives.contractCard', [])
  .directive('contractCard', contractCard)
  .name